exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".embed-slider-wrapper[data-v-b25d97ea]{width:100%;padding-bottom:10px}.v-carousel__controls[data-v-b25d97ea]{display:none!important}.embed-slider-wrapper .v-window-item[data-v-b25d97ea]{padding-left:50px;padding-right:50px}", ""]);

// exports
